// @core/api/endpoints/document/create_document_register.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDocumentRegisterRequest,
  DocumentRegisterResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create register
 * Creates a formal document registration journal for a scope entity.
 */
export async function CreateDocumentRegister(
  data: CreateDocumentRegisterRequest,
  options?: RequestOptions
): Promise<DocumentRegisterResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-registers`;
  const requestOptions = options;
  return client.post<DocumentRegisterResponse>(requestPath, data, requestOptions);
}
